import { forwardRef, type Ref } from 'react';

import { SexType } from '@/lib/types';

import { usePrivate } from '@/components/private/PrivateContext';

import {
  BaseSearchField,
  type BaseSearchFieldApi,
  type BaseSearchFieldProps,
} from '@/primitives';

export interface AnimalSearchFieldProps {
  disabled?: boolean;
  filterBySex?: SexType;
  inputName?: string;
  label: BaseSearchFieldProps['label'];
  onChange: () => void;
  placeholder: BaseSearchFieldProps['placeholder'];
  value?: string | null;
}

function AnimalSearchFieldInner(
  {
    disabled,
    filterBySex,
    inputName,
    label,
    onChange,
    placeholder,
    value,
  }: AnimalSearchFieldProps,
  ref: Ref<BaseSearchFieldApi>,
) {
  const { entityApi } = usePrivate();

  const fetchOptions = async (name: string) => {
    return [];
    if (!entityApi) {
      return [];
    }

    // try {
    //   const result = await entityApi.apiEntityGetEntityFilterByDetailPost(
    //     name,
    //     filterBySex,
    //     10,
    //   );

    //   return result?.data || [];
    // } catch (error) {
    //   console.error(
    //     '[BREEDLOGIC] <AnimalSearchFieldInner>.fetchOptions error',
    //     error,
    //   );
    //   return [];
    // }
  };

  // const handleChange = (value: AnimalSearchDto | string | null) => {
  //   onChange(value);
  // };

  return (
    <BaseSearchField<any | string>
      disabled={disabled}
      freeSolo
      InputProps={{
        name: inputName,
      }}
      fetchOptions={fetchOptions}
      fullWidth
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        return option.name || '';
      }}
      isOptionEqualToValue={(option, value) => {
        if (typeof option === 'string' && typeof value === 'string') {
          return option === value;
        } else if (typeof option === 'string') {
          return option === value;
        } else if (typeof value === 'string') {
          return option.name === value;
        }
        return option.name === value.name;
      }}
      label={label}
      onChange={() => {}}
      placeholder={placeholder}
      ref={ref}
      renderOption={(props, option) => {
        if (typeof option === 'string') {
          return null;
        }
        return (
          <li {...props} key={option.animalId}>
            {option.name}
          </li>
        );
      }}
      value={value}
    />
  );
}

export const AnimalSearchField = forwardRef(AnimalSearchFieldInner);
